import OpenStep from '$common/components/open-step'
import { urlQueries } from '../url/url'
import languageUtils from "$common/utils/language";

export * from './user'

export const lang = (() => {
  const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
  return navigatorLanguage.indexOf("zh") !== -1
    ? "zh"
    : navigatorLanguage.indexOf("en") !== -1
      ? "en"
      : "km";
})()

export const getEnv = () => {
  const origin = window.location.origin
  const isDEV = origin.indexOf('http://') !== -1
  const isSIT = origin.indexOf('https://h5-sit') !== -1
  const isUAT = origin.indexOf('https://h5-uat') !== -1
  const isFAT = origin.indexOf('https://h5-fat') !== -1
  return (isDEV && 'dev') || (isSIT && 'sit') || (isUAT && 'uat') || (isFAT && 'fat') || 'pro'
}

export const lowerCaseUA = navigator.userAgent.toLowerCase();
export const isIOS = navigator.userAgent.toLocaleLowerCase().indexOf("mac os x") !== -1;
export const isAndroid = navigator.userAgent.toLocaleLowerCase().indexOf("android") !== -1;
export const isSafari = isIOS && /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
export const isWownowApp = navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
export const isWechat = navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
export const isFaceBook =
  lowerCaseUA.indexOf("fbav") !== -1 ||
  lowerCaseUA.indexOf("fban") !== -1 ||
  lowerCaseUA.indexOf("fbios") !== -1 ||
  lowerCaseUA.indexOf("facebook") !== -1;
export const shareLogo = "https://img.tinhnow.com/wownow/static/img/share-logo.png?v=123";

let openStepInstance = null
export const showWechatOpenStepModal = () => {
  if (!openStepInstance) {
    const Constructor = Vue.extend(OpenStep)
    openStepInstance = new Constructor({
      propsData: {
        value: false
      }
    }).$mount()
    document.body.appendChild(openStepInstance.$el)
  }
  openStepInstance.show()
}

export const getWechatAppId = () => {
  return window?.ssrConfig?.routerConfig?.appid ?? "";
};

export const getIOSUniversalLink = (route) => {
  const origin = window.location.origin
  const isDEV = origin.indexOf('http://') !== -1
  const isSIT = origin.indexOf('https://h5-sit') !== -1
  const isUAT = origin.indexOf('https://h5-uat') !== -1
  const isFAT = origin.indexOf('https://h5-fat') !== -1
  let href
  if (isDEV || isSIT) {
    href = 'https://m-sit.ozos.xyz/app-wownow-links/wownow/down-loading'
  } else if (isUAT) {
    href = 'https://m-uat.ozos.xyz/app-wownow-links/wownow/down-loading'
  } else if (isFAT) {
    href = 'https://m-fat.ozos.xyz/app-wownow-links/wownow/down-loading'
  } else {
    href = 'https://m.ozos.xyz/app-wownow-links/wownow/down-loading'
  }

  if (route) {
    href = `${href}?routepath=${encodeURIComponent(route)}`
  }

  return href
}

export const getIosUrl = () => {
  // routepath要encode一下
  // return "superapp://h5.lifekh.com/wakeup?routepath="
  return "superapp://h5.lifekh.com/wakeup"
};

// 外面打开的路径，android后面的路径要encode一下
export const getAndroidUrl = () => {
  // const result = "superapp://tinhnow/route?url=";
  // const result = "superapp://tinhnow/route";
  const result = "superapp://wownow/route"
  // const result = "yumnow://"
  return result;
};

export const getAppPath = (query = {
  // ios的定位参数，后面如果是一个url，需要encode一下
  routepath: "",
  // android的定义参数
  url: ""
}) => {
  // console.log(
  //   "get App env: " + (isIOS ? "ios" : isAndroid ? "android" : "unknown")
  // );
  const base = isIOS ? getIosUrl() : getAndroidUrl();
  const queryItems = []

  if (query) {
    Object.keys(query).forEach(key => {
      if (query[key]) {
        if (key === 'url') {
          queryItems.push(`url=${encodeURIComponent(query[key])}`)
        } else {
          queryItems.push(`${key}=${query[key]}`)
        }
      }
    })
  }

  // const result = `${base}${
  //   isIOS ? path : path ? encodeURIComponent(path) : ""
  // }`;
  const result = `${base}?${queryItems.join('&')}`

  console.log("get App path: " + result);
  return result;
};

const createOpenIframe = (src) => {
  const ifr = document.createElement("iframe");
  ifr.src = src;
  ifr.style.cssText = "display:none;border:0;width:0;height:0;";
  document.body.appendChild(ifr);
  setTimeout(() => {
    document.body.removeChild(ifr);
  }, 5000);
}

// 从外面跳app首页
export const goAppHome = (query = {}) => {
  console.log("start go to app home");
  const result = getAppPath(query);
  // 兼容andorid下facebook打开的情况
  if (isFaceBook && isAndroid) {
    console.log("start go to in facebook");
    createOpenIframe(result)
  } else {
    console.log("start go to in other");
    window.location.href = result;
  }
};

const handlerState = {
  handler: function (timeout = 500) {
    let openState = false
    let timmer = setTimeout(() => {
        if (!openState) {
          goDownloadPage()
        }
    }, timeout)
    return function handleInner() {
     
      document.removeEventListener('visibilitychange', handleInner)
      if (document.hidden) {
        openState = true
        clearTimeout(timmer)
        console.log('打开app成功！')
      } else {
        openState = false
        console.log('打开app失败，跳转下载页')
      }
    }
  }
}

// 从外面跳app指定页面
export const goAppPath = (query = {}, autoGoDownloadPage = false, timeout = 500) => {
  if (autoGoDownloadPage) {
    document.addEventListener('visibilitychange', handlerState.handler(timeout))
  }
  const result = getAppPath(query);
  console.log('go app path: ' + result)
  if (isFaceBook && isAndroid) {
    console.log("start go to in facebook");
    createOpenIframe(result)
  } else {
    window.location.href = result;
  }
};

export const innerGoAppPath = (path = "") => {
  window.location.href = path;
};

export const getDownloadPage = () => {
  const origin = window.location.origin
  let base = `/wownow/down-loading`;
  if (process.env.NODE_ENV !== "development") {
    base = `/mobile-h5${base}`;
  }
  const result = origin + base;
  return result
}

export const goGuidePage = () => {
  let base = `/wownow/guide-page`;
  if (process.env.NODE_ENV !== "development") {
    base = `/mobile-h5${base}`;
  }
  const result = window.location.origin + base;
  window.location.href = result;
}

export const goDownloadPage = (ops = { query: {} }) => {
  const urlParams = urlQueries()
  const { query = {} } = ops;
  const queryList = []
  const autoParams = ['channel']

  Object.keys(urlParams).forEach(key => {
    if (autoParams.includes(key) && !query[key]) {
      query[key] = urlParams[key]
    }
  })

  Object.keys(query).forEach(key => {
    queryList.push(`${key}=${query[key]}`)
  })
  const queryStr = queryList.length ? queryList.join('&') : ''
  console.log(`start: download query ${queryStr}`);
  let base = `/wownow/down-loading?${queryStr}`;
  if (process.env.NODE_ENV !== "development") {
    base = `/mobile-h5${base}`;
  }
  const result = window.location.origin + base;
  console.log(`doing: download href: ${result}`);
  console.log("href going");
  // window.location.replace(result)
  window.location.href = result;
};

/**
 *
 * @param {*} param0 {
 *    query: 传递给下载页需要的 参数
 *    timeout: 延迟打开下载页的定时器时长
 * }
 */
export const goDownloadPageAfterTryOpenApp = (
  ops = { query: {}, timeout: 500 }
) => {
  const { query, timeout } = ops;
  goAppPath(query);
  setTimeout(() => {
    goDownloadPage({ query });
  }, timeout);
};
// 创建scirpt标签
export const createScriptDom = (src) => {
  return new Promise(function(resolve, reject) {
    try {
      var script = document.createElement("script");
      script.src = src;
      script.type = "text/javascript";
      // 兼容性处理：检测脚本加载状态
      if ("onload" in script) {
        // iOS, Android和现代浏览器
        script.onload = resolve;
        script.onerror = reject;
      } else {
        // 其他老旧的浏览器（如部分Android）
        script.onreadystatechange = function() {
          if (
            script.readyState === "loaded" ||
            script.readyState === "complete"
          ) {
            script.onreadystatechange = null;
            resolve();
          }
        };
      }
      document.head.appendChild(script);
      // document.head.removeChild(script);
    } catch (error) {
      console.log(error);
    }
  });
}
